import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import Button from "semantic-ui-react/dist/es/elements/Button";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
// import { Redirect } from "react-router-dom";
import { Redirect, Link } from "react-router-dom";
import { send2FAOTP, signIn } from "../../actions/authAction";
import "./Login.scss";
import SocialLogin from "./SocialLogin/SocialLogin";
import { toast } from "react-toastify";
import { ReactComponent as EyeClose } from "../../assets/svg/password-hide.svg";
import { ReactComponent as EyeOpen } from "../../assets/svg/password-show.svg";
import moment from "moment";
import { updateRouteValues } from "../../actions/globalAction";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            otp: "",
            showPassword: false,
            signedIn: false,
            signInLoading: false,
            otpSent: false,
            auth_id: null,
        };
    }

    componentDidMount() {
        document.title = this.props.wlSignIn ? "Login - Best Social Listening Platform" : "Login to Radarr - Best Social Listening Platform";
        let isSessionTimedOut = sessionStorage.getItem("isSessionTimedOut");
        if (isSessionTimedOut != null || isSessionTimedOut != undefined) {
            const diff = moment().diff(moment(+isSessionTimedOut), "second", true);
            if (diff < 4) {
                toast.error("Session timed out. Please Sign In again.");
            } else {
                sessionStorage.removeItem("isSessionTimedOut");
            }
        }
    }
    componentDidUpdate(prevProps) {
        // console.log("kllkklkllkl",window.location.pathname)
        //  ReactGA.pageview(window.location.pathname + window.location.search);
        if (prevProps.location?.pathname != window.location?.pathname) {
            let route = {
                to: window.location?.pathname,
                from: prevProps.location?.pathname,
            };
            this.props.updateRouteValues(route);
        }
    }

    submitForm = (e) => {
        if (this.state.signInLoading) return;
        e.preventDefault();
        const { username, password } = this.state;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&*])(?=.{8,})/;
        let format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
        if (username === "") {
            toast.error("Please enter a valid company email.");
            return;
        } else if (password === "") {
            toast.error("Please enter your password");
            return;
        } else if (password.length < 8) {
            toast.error("Please enter a valid password");
            return;
        } else if (!format.test(password)) {
            toast.error("Please enter a valid password");
            return;
        }
        this.setState({ signInLoading: true });
        this.props
            .signIn({ username, password })
            .then((res) => {
                // console.log(res);
                if (res?.value?.status === "success") {
                    if (res.value.data.two_factor_auth_required) {
                        return this.send2FAOTP(res.value.data.auth.id);
                    } else {
                        this.setAccessToken(res.value.data);
                    }
                }
                return res;
            })
            .then(() => {
                this.setState({ signInLoading: false });
            });
    };

    send2FAOTP = (auth_id) => {
        this.setState({ signInLoading: true, auth_id });
        return this.props.send2FAOTP({ auth_id }).then((response) => {
            // console.log(response);
            if (response?.value?.status === "success") {
                toast.success("OTP has been sent to you email address");
                this.setState({ otpSent: true, signInLoading: false });
            }
        });
    };

    verifyOTP = (e) => {
        if (this.state.signInLoading) return;
        e.preventDefault();

        const { username, password, otp } = this.state;

        if (!otp) {
            toast.error("Please enter a valid OTP");
            return;
        }

        this.setState({ signInLoading: true });
        this.props
            .signIn({ username, password, two_factor_token: otp })
            .then((res) => {
                // console.log(res);
                if (res?.value?.status === "success") {
                    this.setAccessToken(res.value.data);
                } else {
                    this.setState({ signInLoading: false });
                }
            })
            .then(() => {
                this.setState({ signInLoading: false });
            });
    };

    setAccessToken = (data) => {
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("userId", data.user.id);
        this.setState({ signedIn: true, signInLoading: false });
    };

    inputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
    showPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    render() {
        return (
            <div className={`login-form-container ${this.props.wlSignIn && "wl__whit__bg"}`}>
                <h2 className="login-form-header">Sign In</h2>
                {/* <div className="header__container">
                    <h2 className="form__heading">Sign In</h2>
                    {/* <p className="form__para">No credit card needed</p> */}
                {/* </div> */}
                <form className="login-form" onSubmit={this.submitForm}>
                    {!this.state.otpSent && (
                        <>
                            <div className="login-form-input-group">
                                <p className="login-form-label">Company Email*</p>
                                <input
                                    name="username"
                                    type="text"
                                    placeholder="Enter Company Email"
                                    className="login-form-input"
                                    value={this.state.username}
                                    onChange={this.inputChange}
                                />
                            </div>
                            <div className="login-form-input-group">
                                <p className="login-form-label">Password*</p>
                                <div className="password__field-wrap">
                                    <input
                                        name="password"
                                        type={this.state.showPassword ? "text" : "password"}
                                        placeholder="Enter Password"
                                        className="login-form-input password-input"
                                        value={this.state.password}
                                        onChange={this.inputChange}
                                    />
                                    {
                                        <span className="eye__btn" onClick={this.showPassword}>
                                            {this.state.showPassword ? (
                                                <EyeOpen className="eye__icon" title="Hide Password" />
                                            ) : (
                                                <EyeClose className="eye__icon" title="Show Password" />
                                            )}
                                        </span>
                                    }
                                </div>
                                {!this.props.wlSignIn && (
                                    <p className="forgot-password">
                                        <Link to="/forgetpassword" className="forget__link">
                                            Forgot Password
                                        </Link>
                                    </p>
                                )}
                            </div>
                        </>
                    )}
                    {this.state.otpSent && (
                        <>
                            <div className="login-form-input-group">
                                <p className="login-form-label">Verification OTP*</p>
                                <input
                                    name="otp"
                                    type="text"
                                    placeholder="Enter OTP sent to your email"
                                    className="login-form-input"
                                    value={this.state.otp}
                                    onChange={this.inputChange}
                                />
                                <div className="resend-code">
                                    {!this.state.signInLoading && <ResendCode resendCode={() => this.send2FAOTP(this.state.auth_id)} />}
                                </div>
                            </div>
                        </>
                    )}
                    <button className="sign-in-button" onClick={(e) => (this.state.otpSent ? this.verifyOTP(e) : this.submitForm(e))}>
                        <span>{!this.state.signInLoading ? "Sign In" : <Loader inverted active size="small" />}</span>
                    </button>
                </form>
                <SocialLogin routeTo={"/signup"} wlSignIn={this.props.wlSignIn} />
                <div className="privacy__policy">
                    <a href="https://www.radarr.com/terms-of-use/" target="_blank" rel="noreferrer">
                        <span className="privacy__text">Terms and Conditions </span>
                    </a>{" "}
                    <span className="privacy__text-separate"> | </span>{" "}
                    <a href="https://www.radarr.com/privacypolicy" target="_blank" rel="noreferrer">
                        {" "}
                        <span className="privacy__text">Privacy Policy </span>
                    </a>
                </div>
                {!this.props.showGettingStarted && this.state.signedIn && <Redirect to="/home" />}
                {this.props.showGettingStarted && this.state.signedIn && <Redirect to="/gettingStarted" />}
            </div>
        );
    }
}

const ResendCode = ({ resendCode }) => {
    const [time, updateTime] = useState(30);

    useEffect(() => {
        setTimeout(() => updateTime(time - 1), 1000);
    }, []);

    useEffect(() => {
        if (time > 0) {
            setTimeout(() => updateTime(time - 1), 1000);
        } else {
            updateTime(0);
        }
    }, [time]);

    if (time === 0) return <span onClick={resendCode}>Resend code</span>;
    else return <span>Resend in... {time} secs</span>;
};

const mapStateToProps = (state) => {
    return {
        // signInLoading: state.authReducer.signInLoading,
        // signedIn: state.authReducer.signedIn,
        showGettingStarted: state.globalReducer.showGettingStarted,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signIn: (data) => dispatch(signIn(data)),
        updateRouteValues: (args) => dispatch(updateRouteValues(args)),
        send2FAOTP: (args) => dispatch(send2FAOTP(args)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
